import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { sendPrivateNotification, SendPrivateNotificationParams } from "@/services/adminNotificationService";
import { sendBroadcastNotification, BroadcastParams, getBroadcastHistory } from "@/services/broadcastService";
import { toast } from "sonner";

export const useAdminNotifications = () => {
  const queryClient = useQueryClient();

  const sendPrivate = useMutation({
    mutationFn: sendPrivateNotification,
    onSuccess: () => {
      toast.success("Notificación enviada exitosamente");
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
      queryClient.invalidateQueries({ queryKey: ["admin-audit-log"] });
    },
    onError: (error: any) => {
      console.error("Error sending private notification:", error);
      toast.error(error.message || "Error al enviar la notificación");
    }
  });

  const sendBroadcast = useMutation({
    mutationFn: sendBroadcastNotification,
    onSuccess: (data) => {
      toast.success(`Notificación broadcast enviada a ${data.recipients} usuarios`);
      queryClient.invalidateQueries({ queryKey: ["broadcast-history"] });
      queryClient.invalidateQueries({ queryKey: ["admin-audit-log"] });
    },
    onError: (error: any) => {
      console.error("Error sending broadcast notification:", error);
      toast.error(error.message || "Error al enviar la notificación broadcast");
    }
  });

  const broadcastHistory = useQuery({
    queryKey: ["broadcast-history"],
    queryFn: getBroadcastHistory,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });

  return {
    sendPrivate,
    sendBroadcast,
    broadcastHistory,
    isSending: sendPrivate.isPending || sendBroadcast.isPending
  };
};
